import { Phone, Mail, MapPin } from "lucide-react";

// Official brand marks (Simple Icons paths — currentColor fill for theming)
const InstagramIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <title>Instagram</title>
    <path d="M12 2.163c3.204 0 3.584.012 4.849.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.85-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const FacebookIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <title>Facebook</title>
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const LinkedinIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <title>LinkedIn</title>
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const PRODUCT_LINKS = [
  { label: "Steel Windows", href: "/products/steel-windows" },
  { label: "Steel Doors", href: "/products/steel-doors" },
  { label: "Luxury Entrances", href: "/products/luxury-entrances" },
  { label: "Hardware", href: "/products/hardware" },
  { label: "Designs", href: "/products/designs" },
  { label: "Finishes", href: "/finishes" },
];

const STUDIO_LINKS = [
  { label: "Our Process", href: "/#process" },
  { label: "Our Story", href: "/#our-story" },
  { label: "Projects", href: "/projects" },
  { label: "Door Configurator", href: "/door-configurator" },
  { label: "Technical", href: "/technical" },
  { label: "Track Your Order", href: "/order-status" },
  { label: "FAQ", href: "/faq" },
  { label: "Terms & Warranty", href: "/terms" },
];

const SOCIALS = [
  {
    label: "Instagram",
    handle: "@eurosteelnz",
    href: "https://www.instagram.com/eurosteelnz",
    Icon: InstagramIcon,
    testid: "footer-social-instagram",
  },
  {
    label: "Facebook",
    handle: "Eurosteel NZ",
    href: "https://www.facebook.com/eurosteelnz",
    Icon: FacebookIcon,
    testid: "footer-social-facebook",
  },
  {
    label: "LinkedIn",
    handle: "Eurosteel",
    href: "https://www.linkedin.com/company/eurosteel-nz",
    Icon: LinkedinIcon,
    testid: "footer-social-linkedin",
  },
];

const linkCls =
  "font-body text-sm text-white/70 transition-colors hover:text-[#c6a87c]";
const columnHeadingCls =
  "font-tech mb-5 text-[10px] uppercase tracking-[0.3em] text-white/40";

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative overflow-hidden border-t border-white/10 bg-[#0a0a0c] px-6 pb-12 pt-24 lg:px-16"
    >
      <div className="mx-auto max-w-[1600px]">
        <h2 className="font-body text-[13vw] font-light uppercase leading-none tracking-[0.15em] text-[#c6a87c] lg:text-[9rem]">
          EUROSTEEL
        </h2>

        <div className="mt-20 grid grid-cols-2 gap-10 border-t border-white/10 pt-12 md:grid-cols-4">
          {/* Products */}
          <div>
            <p className={columnHeadingCls}>Products</p>
            <ul className="space-y-3">
              {PRODUCT_LINKS.map((i) => (
                <li key={i.label}>
                  <a href={i.href} data-testid={`footer-link-${i.label.toLowerCase().replace(/\s+/g, "-")}`} className={linkCls}>
                    {i.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Studio */}
          <div>
            <p className={columnHeadingCls}>Studio</p>
            <ul className="space-y-3">
              {STUDIO_LINKS.map((i) => (
                <li key={i.label}>
                  <a href={i.href} data-testid={`footer-link-${i.label.toLowerCase().replace(/\s+/g, "-")}`} className={linkCls}>
                    {i.label}
                  </a>
                </li>
              ))}
            </ul>
            <a
              href="https://archipro.co.nz/professional/eurosteel"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-badge-archipro"
              aria-label="Featured on ArchiPro"
              className="relative mt-8 block h-16 w-56 overflow-hidden transition-opacity duration-500 hover:opacity-80"
            >
              <img
                src="https://customer-assets-rejwkqb3.emergentagent.net/job_7c966369-8b86-4034-b768-cad248e60af9/artifacts/6do9mgj2_archipro.png"
                alt="Featured on ArchiPro"
                className="pointer-events-none absolute left-1/2 top-1/2 w-full max-w-none -translate-x-1/2 -translate-y-1/2"
              />
            </a>
          </div>

          {/* Contact */}
          <div>
            <p className={columnHeadingCls}>Contact</p>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-white/70">
                <Phone size={14} className="mt-1 shrink-0 text-[#c6a87c]" />
                <a
                  href="tel:+64279152526"
                  data-testid="footer-phone"
                  className={linkCls}
                >
                  +64 27 915 2526
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/70">
                <Mail size={14} className="mt-1 shrink-0 text-[#c6a87c]" />
                <a
                  href="mailto:isaiah@euro-steel.co.nz"
                  data-testid="footer-email-isaiah"
                  className={linkCls}
                >
                  isaiah@euro-steel.co.nz
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/70">
                <Mail size={14} className="mt-1 shrink-0 text-[#c6a87c]" />
                <a
                  href="mailto:orders@euro-steel.co.nz"
                  data-testid="footer-email-orders"
                  className={linkCls}
                >
                  orders@euro-steel.co.nz
                </a>
              </li>
              <li className="pt-3">
                <p className="font-tech text-[10px] uppercase tracking-[0.28em] text-white/40">
                  Showroom
                </p>
                <a
                  href="https://maps.google.com/?q=3+Byron+Avenue+Takapuna+Auckland"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-showroom-address"
                  className="mt-2 flex items-start gap-2 font-body text-sm leading-relaxed text-white/70 transition-colors hover:text-[#c6a87c]"
                >
                  <MapPin size={14} className="mt-1 shrink-0 text-[#c6a87c]" />
                  <span>
                    3 Byron Avenue, Takapuna
                    <br />
                    Auckland, New Zealand
                  </span>
                </a>
              </li>
              <li className="pt-1">
                <p className="font-tech text-[10px] uppercase tracking-[0.28em] text-white/40">
                  Hours
                </p>
                <p className="mt-1 font-body text-sm leading-relaxed text-white/70">
                  Mon – Fri · 8:30 – 5:00
                  <br />
                  Showroom by appointment
                </p>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <p className={columnHeadingCls}>Connect</p>
            <ul className="space-y-3">
              {SOCIALS.map(({ label, handle, href, Icon, testid }) => (
                <li key={label}>
                  <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={testid}
                    className="group flex items-center gap-3 text-white/70 transition-colors hover:text-[#c6a87c]"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 transition-all duration-300 group-hover:border-[#c6a87c] group-hover:bg-[#c6a87c]/10">
                      <Icon width={15} height={15} />
                    </span>
                    <span className="flex flex-col">
                      <span className="font-tech text-[10px] uppercase tracking-[0.28em] text-white/40">
                        {label}
                      </span>
                      <span className="font-body text-sm">{handle}</span>
                    </span>
                  </a>
                </li>
              ))}
            </ul>

            <div className="mt-8 border-t border-white/10 pt-6">
              <p className="font-body text-sm leading-relaxed text-white/70">
                Quotes, project drawings and lead times.
              </p>
              <a
                href="mailto:isaiah@euro-steel.co.nz?subject=Eurosteel%20Enquiry"
                data-testid="footer-enquire-button"
                className="mt-5 inline-block rounded-full bg-[#c6a87c] px-8 py-3 font-tech text-[11px] uppercase tracking-[0.2em] text-[#0a0a0c] transition-all duration-500 hover:bg-[#d8bd93]"
              >
                Enquire
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-8 md:flex-row md:items-center">
          <div className="flex flex-col gap-1.5">
            <p className="font-tech text-[10px] uppercase tracking-[0.25em] text-white/40">
              © {new Date().getFullYear()} Eurosteel — All rights reserved
            </p>
            <p
              data-testid="footer-finish-disclaimer"
              className="max-w-2xl font-body text-[10px] leading-relaxed text-white/30"
            >
              Colours and finishes shown on screen are indicative only. Actual finishes may vary due to display calibration, lighting and material batch. Please request physical samples before final specification.
            </p>
          </div>
          <div className="flex flex-wrap gap-6">
            <a
              href="/terms"
              data-testid="footer-terms-link"
              className="font-tech text-[10px] uppercase tracking-[0.25em] text-white/40 transition-colors hover:text-[#c6a87c]"
            >
              Terms & Warranty
            </a>
            <a
              href="/order-status"
              data-testid="footer-track-order-link"
              className="font-tech text-[10px] uppercase tracking-[0.25em] text-white/40 transition-colors hover:text-[#c6a87c]"
            >
              Track Order
            </a>
            <p className="font-tech text-[10px] uppercase tracking-[0.25em] text-white/40">
              Steel Windows · Doors · Aluminium Systems
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
